
import { Component, Vue } from "vue-property-decorator";

@Component({
  meta: {
    title: "Политика конфиденциальности"
  }
})
export default class PrivacyPolicy extends Vue {}
